import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {Box,Tab,Tabs,AppBar,Typography,Grid,TextField,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Card,CardContent,CardHeader} from '@mui/material';
import PropTypes from 'prop-types';
import unsplash from "../api/unsplash";
import moment from "moment";
import momentTimezone from "moment-timezone";
import "moment/locale/it";
import { DatePicker ,LocalizationProvider} from "@mui/lab";
import DateAdapter from '@mui/lab/AdapterMoment';
import ProtocolloSanitarioLavoratore from "./ProtocolloSanitarioLavoratore";

const DettaglioCliente = (props) => {

    const location = useLocation();
    const [value, setValue] = useState(0);
    const [clienti,setClienti] = useState();
    const [lavoratore,setLavoratore] = useState(location.state.lavoratore);
    const [lavoratoreCopy,setLavoratoreCopy] = useState(location.state.lavoratore);
    const [sedi,setSedi] = useState();
    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
      }

      useEffect(() => {// è un loop qui carico i dati 
        const fetchData = async () =>{
          let responseSedi =  await unsplash
          .get('sedi',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:location.state.lavoratore.Cliente}}
           );
          console.log(location.state.lavoratore);
      
           setSedi(responseSedi.data.data);
        }
    
        fetchData();
     
      }, []);

const handleChange = (e) => {
let lav = {...lavoratore};
lav[e.target.name] = e.target.value;
setLavoratore(lav);
}
    
return (
<>
<Grid item xs={12}>
<Card>
  <CardHeader sx={{textAlign:"center"}} title={lavoratoreCopy.Nome+" "+lavoratoreCopy.Cognome }  titleTypographyProps={{variant:'h4' }}/>
  </Card>
  <Card sx={{marginTop:"10px"}}>
  <CardContent>
<Box >

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
     
          <Tabs value={value} textColor="inherit" variant="scrollable" onChange={handleChangeTab} aria-label="basic tabs example">
            <Tab label="Generali" {...a11yProps(0)} />
            <Tab label="Protocollo Sanitario" {...a11yProps(1)} />
            <Tab label="Visite" {...a11yProps(2)} />
            <Tab label="Corsi" {...a11yProps(3)} />
            <Tab label="Allegati" {...a11yProps(4)} />
          </Tabs>
          </Box>
        <TabPanel value={value} index={0}>{/*GEnerali*/}
        
  { lavoratore?    
  <Grid container spacing={2}>    
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="Nome" value={lavoratore.Nome} name="Nome" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="Cognome" value={lavoratore.Cognome} name="Cognome" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <TextField id="outlined-basic" label="CF" value={lavoratore.CF} name="CF" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={6}>
  <FormControl fullWidth>
  <InputLabel id="demo-multiple-name-label">Sesso</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={lavoratore.Sesso}
          input={<OutlinedInput label="Name" />}>
          
            <MenuItem value={1}>Maschio</MenuItem>
            <MenuItem value={2}>Femmina</MenuItem>
        </Select>
        </FormControl>
  </Grid>
  <Grid item xs={12} md={4}>
  <FormControl fullWidth>
  <InputLabel id="demo-multiple-name-label">Sede</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          input={<OutlinedInput label="Name" />}
          name="Sede"
          defaultValue={lavoratore.Sede}
        >
          {sedi?.map((sede) => (
            <MenuItem
              key={sede.ID}
              value={sede.ID}
            
            >
              {sede.Descrizione +" - "+ sede.Blocco}
            </MenuItem>
          ))}
        </Select>
        </FormControl>
  </Grid>
  <Grid item xs={12} md={4}>
  <LocalizationProvider dateAdapter={DateAdapter}>
  <DatePicker

  ampmInClock={false}
    renderInput={(props) => <TextField {...props} fullWidth />}
    label="Data Nascita"
    value={lavoratore.DataDiNascita}
  />
</LocalizationProvider>
  </Grid>
  <Grid item xs={12} md={4}>
  <LocalizationProvider dateAdapter={DateAdapter}>
  <DatePicker

  ampmInClock={false}
    renderInput={(props) => <TextField {...props} fullWidth/>}
    label="Data Assunzione"
    value={lavoratore.DataAssunzione}
 
  />
</LocalizationProvider>
  </Grid>
  <Grid item xs={12} md={4}>
  <LocalizationProvider dateAdapter={DateAdapter}>
  <DatePicker

  ampmInClock={false}
    renderInput={(props) => <TextField {...props} fullWidth/>}
    label="Data Fatturazione Costi Gestione"
    value={lavoratore.DtaCostiGestione}
 
  />
</LocalizationProvider>
  </Grid>
  <Grid item xs={12} md={4}>
  <LocalizationProvider dateAdapter={DateAdapter}>
  <DatePicker

  ampmInClock={false}
    renderInput={(props) => <TextField {...props} fullWidth/>}
    label="Data Termine"
    value={lavoratore.DataTermine}
 
  />
</LocalizationProvider>
  </Grid>
  <Grid item xs={12} md={4}>
  <TextField id="outlined-basic" label="Telefono" value={lavoratore.Telefono} name="Telefono" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={4}>
  <TextField id="outlined-basic" label="Email" value={lavoratore.Email} name="Email" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={4}>
  <TextField id="outlined-basic" label="Note" value={lavoratore.Note} name="Note" onChange={handleChange} fullWidth/>
  </Grid>
  <Grid item xs={12} md={4}>
  <TextField id="outlined-basic" label="Distaccato" value={lavoratore.Distaccato} name="Distaccato" onChange={handleChange} fullWidth/>
  </Grid>


</Grid> :""}
        
        </TabPanel>
        <TabPanel value={value} index={1}>{/*Protocollo sanitario*/}
        
     <ProtocolloSanitarioLavoratore lavoratore={location.state.lavoratore.ID} />
        
        </TabPanel>
        <TabPanel value={value} index={2}>
        Tabella con Organigramma
        </TabPanel>
        <TabPanel value={value} index={3}>
          Item 4
        </TabPanel>
        <TabPanel value={value} index={4}>
          Item 5
        </TabPanel>
      </Box>
      </CardContent>
      </Card>
      </Grid>
      </>


)





}




function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  









export default DettaglioCliente